import React from 'react';

import ColgateSupervisorDetalle from 'components/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Colgate/Supervisor/SupervisorDetalle/List.js';

export default function () {
  return <ColgateSupervisorDetalle />;
}
